function Average(){
    // private
    function getInputDataLength(inputData){
        for (var datasetId in inputData){
            return inputData[datasetId].length;
        }

        return 0;
    }

    // public
    this.derive = function(inputData, inputDataParameters, derivedDataDatasetId){
        var derivedData = [];
        var inputDataLength = getInputDataLength(inputData);

        for (var i=0; i<inputDataLength; ++i){
            var averageData = getAverageDataOfIndex(i);
            derivedData.push(averageData);
        }

        return derivedData;

        function getAverageDataOfIndex(index){
            var sum = 0;
            var numNonNulls = 0;
            var timestamp;
            var average;

            for (var j=0; j<inputDataParameters.length; ++j){
                var datasetId = inputDataParameters[j].datasetId;
                var fieldId = inputDataParameters[j].fieldId;
                if (inputData[datasetId][index] != null && inputData[datasetId][index][fieldId] != null){
                    sum += inputData[datasetId][index][fieldId];
                    numNonNulls++;
                }

                if (inputData[datasetId][index] != null){
                    timestamp = inputData[datasetId][index].timestamp;
                }
            }

            if (numNonNulls != 0){
                return {
                    dataset: derivedDataDatasetId,
                    value: average = sum / numNonNulls,
                    timestamp: timestamp
                };
            }
            else{
                average = null;
            }

            return null;
        }
    }
}

module.exports = new Average();


// WEBPACK FOOTER //
// ./src/core/services/data-service/derived-datasets/average.js